const EmojiPath = "//devcdn.xylink.com/libs/jquery/emoji/src/img/nemo/";

const EmojiObj = {
  1: "哈哈",
  2: "可爱",
  3: "亲",
  4: "鬼脸",
  5: "呲牙",
  6: "大笑",
  7: "汗",
  8: "鲜花",
  9: "庆祝",
  10: "嘴唇",
  11: "强",
  12: "弱",
  13: "鼓掌",
  14: "加油"
};

/**
 *
 * @param text {string}
 * @return {string}
 */
export const stringToDom = (text: string) => {
  if (text === undefined) {
    return "";
  }
  return transformString(
    {
      icons: [
        {
          path: EmojiPath,
          maxNum: 16,
          file: ".png",
          pattern: /\[([\u4e00-\u9fa5]+?)\]/gm,
          alias: EmojiObj
        }
      ]
    },
    text
  );
};

/**
 *
 * @param option {Object}
 * @param rawText   {string}
 */

// @ts-ignore
const transformString = (option: any, rawText: string) => {
  const iconsGroup = option.icons;
  const groupLength = iconsGroup.length;
  // @ts-ignore
  const placeholder;
  const revertAlias = {};
  let path: any;
  let file: any;
  let alias: any;
  let pattern: any;
  let regexp: any;

  if (groupLength > 0) {
    for (let i = 0; i < groupLength; i++) {
      path = iconsGroup[i].path;
      file = iconsGroup[i].file || ".jpg";
      regexp = iconsGroup[i].pattern;
      alias = iconsGroup[i].alias;
      if (!path) {
        alert("Path not config!");
        continue;
      }
      if (alias) {
        for (const attr in alias) {
          if (alias.hasOwnProperty(attr)) {
            revertAlias[alias[attr]] = attr;
          }
        }
        return replaceText(rawText, regexp, path, file, revertAlias);
      } else {
        // @ts-ignore
        pattern = placeholder.replace(new RegExp("{alias}", "gi"), "(\\d+?)");
        return rawText.replace(
          new RegExp(pattern, "gm"),
          '<img class="emoji_icon" src="' + path + "$1" + file + '"/>'
        );
      }
    }
  }
};

const replaceText = (
  rawText: string,
  regexp: string,
  path: string,
  file: string,
  revertAlias: any
) => {
  return rawText.replace(regexp, ($0: any, $1: any) => {
    const n = revertAlias[$1];
    if (n) {
      return '<img class="emoji_icon" src="' + path + n + file + '"/>';
    } else {
      return $0;
    }
  });
};



// WEBPACK FOOTER //
// ./src/pc/component/sidebar/component/InteractiveChatRoom/handleEmoji.ts